<template>
  <div>
    <h1 class="pb-3">Produtos Entregáveis</h1>
    <p>
      Os resultados e produtos obtidos serão integralmente destinados ao
      cliente, em formato SEG-Y, padrão ANP1B, via FTP e, também, gravados em
      DVD, incluindo-se:
    </p>

    <h5 class="pt-2">
      Produtos da sísmica 2D – processamento/reprocessamento em tempo
    </h5>
    <BeautifulList v-bind:items="produtos_sismica_2d_tempo" />

    <h5 class="pt-2">
      Produtos da sísmica 2D – processamento em profundidade
    </h5>
    <BeautifulList v-bind:items="produtos_sismica_2d_profundidade" />

    <h5 class="pt-2">
      Produtos da sísmica 3D - processamento em tempo
    </h5>
    <BeautifulList v-bind:items="produtos_sismica_3d_tempo" />
  </div>
</template>

<script>
import BeautifulList from "@/components/BeautifulList.vue";

export default {
  name: "ProdutosEntregaveis",
  components: {
    BeautifulList,
  },
  data() {
    return {
      produtos_sismica_2d_tempo: [
        { id: "A", text: "Linhas sísmicas migradas pós-empilhamento em tempo" },
        { id: "B", text: "Linhas sísmicas migradas pré-empilhamento em tempo" },
        {
          id: "C",
          text:
            "Linhas sísmicas migradas pós-empilhamento em tempo com a técnica CRS",
        },
        {
          id: "D",
          text: "Funções e campo das velocidades finais, de cada linha sísmica",
        },
        {
          id: "E",
          text:
            "Arquivos de coordenadas UTM, da posição de cada traço empilhado",
        },
        {
          id: "F",
          text:
            "Relatório do processamento, detalhando o processamento e controle de qualidade, testes realizados e resultados obtidos, com figuras ilustrativas",
        },
        {
          id: "G",
          text:
            "Arquivos em DVD, contendo os itens (B), (D) e (E) no formato ANP-1B – para serem destinados ao ANP/BDEP",
        },
      ],
      produtos_sismica_2d_profundidade: [
        {
          id: "A",
          text: "Linhas sísmicas migradas pré-empilhamento em profundidade",
        },
        {
          id: "B",
          text:
            "Funções e campo das velocidades finais, em profundidade, de cada linha sísmica",
        },
        {
          id: "C",
          text:
            "Arquivos de coordenadas UTM, da posição de cada traço empilhado",
        },
        {
          id: "D",
          text:
            "Relatório do processamento, detalhando o processamento e controle de qualidade, testes realizados e resultados obtidos, com figuras ilustrativas",
        },
      ],
      produtos_sismica_3d_tempo: [
        {
          id: "A",
          text: "Volume sísmico empilhado e migrado pós-empilhamento;",
        },
        {
          id: "B",
          text: "Volume sísmico migrado pré-empilhamento e empilhado",
        },
        {
          id: "C",
          text:
            "Volume sísmico migrado pós-empilhamento, processado com tecnologia CRS (opcional)",
        },
        {
          id: "D",
          text:
            "Volume contendo o campo de velocidades da migração pré-empilhamento",
        },
        {
          id: "E",
          text:
            "Arquivo de coordenadas do centro de células do volume sísmico empilhado",
        },
        {
          id: "F",
          text:
            "Relatório do processamento, detalhando o processamento e controle de qualidade, testes realizados e resultados obtidos, com figuras ilustrativas",
        },
        {
          id: "G",
          text:
            "Arquivos em DVD, contendo os itens (B), (D) e (E), no formato ANP-1B – destinados à ANP/BDEP",
        },
      ],
    };
  },
};
</script>
